<div
  class="hierarchy-filter dropdown"
  [ngClass]="{
    'is-active': isOpen,
    'display-from-filter': displayFromFilter,
    'is-hidden': displayFromFilter && !isOpen
  }"
>
  <a class="is-hidden" (click)="openContent()" id="filter-organisations-detail">
    <i class="fas fa-chevron-right" aria-hidden="true"></i>
  </a>
  <div class="dropdown-trigger" *ngIf="!displayFromFilter">
    <button
      [attr.aria-expanded]="isOpen"
      id="orgFilterButton"
      [className]="isNewDesignFilter ? 'button is-filter ' : 'button is-chip is-size-7-mobile'"
      [class.is-applied]="getValues().length"
      [class.is-active]="isOpen"
      (click)="itemToggled.emit()"
      (keydown.space)="onKeyDownSpace()"
      title="{{ title }}"
      type="button"
    >
      <span>{{ title }}</span>
      <span class="icon">
        <i class="fas fa-chevron-down"></i>
      </span>
    </button>
  </div>
  <div
    class="dropdown-menu"
    [ngClass]="{
      'display-filter-menu': displayFromFilter,
      'desktop-min-width': !(isDeviceMobile$ | async),
    }"
  >
    <div class="dropdown-content">
      <div class="dropdown-item">
        <div class="field is-grouped is-flex-wrap-wrap">
          <div class="control mr-3 my-1" *ngFor="let searchParameter of searchParameterList">
            <label
              class="radio"
              attr.data-e2e="radio-search-parameter-label-{{ searchParameter.id }}"
            >
              <input
                [value]="searchParameter.id"
                [(ngModel)]="searchParameterType"
                type="radio"
                attr.data-e2e="radio-search-parameter-{{ searchParameter.id }}"
              />
              <span>{{ searchParameter.text }}</span>
            </label>
          </div>
        </div>
      </div>

      <hr class="dropdown-divider" />
      <div class="dropdown-item">
        <portal-search-filter-autocomplete-input
          [placeholder]="searchPlaceholder"
          [searchInputValue]="searchedText"
          [direction]="Directions.RIGHT"
          (search)="onSearch($event)"
        ></portal-search-filter-autocomplete-input>
      </div>

      <div class="field is-grouped flex-end" *ngIf="displaySubOrganisationCheckBox">
        <div class="control toggle-label has-toggle-label">
          <label for="hierarchy" i18n>Include sub-organisations</label>
        </div>
        <div class="control">
          <label class="toggle">
            <input
              id="hierarchy"
              type="checkbox"
              name="{{ hierarchy }}"
              [checked]="isCheckedDefault"
              (click)="onCheckboxToggle()"
              attr.data-e2e="{{ hierarchy }}-input-checkbox"
            />
            <span></span>
          </label>
        </div>
      </div>

      <hr class="dropdown-divider" />

      <div class="dropdown-item has-text-truncate" [class.is-hidden]="!(loading$ | async)">
        <span class="has-text-truncate">
          <portal-spinner
            [isHorizontal]="true"
            [isSmall]="true"
            text="Loading organisations..."
            i18n-text
          ></portal-spinner>
        </span>
      </div>

      <div class="dropdown-item" [class.is-hidden]="loading$ | async" (scroll)="onScrolled($event)">
        <span class="has-text-truncate" *ngIf="!entities?.length && searchedText">
          {{ notFoundMessage }}
        </span>

        <!-- tree -->
        <tree-root
          #tree
          [options]="options"
          [nodes]="entities"
          [state]="treeState"
          (stateChange)="onStateChange($event)"
          (activate)="onActivateEntity($event.node.data)"
          (deactivate)="onDeactivateEntity($event.node?.data)"
          (focusin)="onFocusIn($event, tree.treeModel)"
          (focusout)="onFocusOut($event, tree.treeModel)"
          (keydown.arrowRight)="onKeyDownArrowRight($event, tree.treeModel)"
          tabindex="0"
        >
          <ng-template #treeNodeWrapperTemplate let-node let-index="index">
            <div
              #treeNode
              [attr.data-id]="node.id"
              class="is-align-items-start node-wrapper"
              [style.padding-left]="node.getNodePadding()"
              tabindex="-1"
            >
              <tree-node-expander
                class="is-align-content-baseline"
                [node]="node"
                role="button"
                tabindex="0"
                aria-label="Toggle node"
                (keydown.enter)="node.toggleExpanded(); $event.preventDefault()"
                (keydown.space)="node.toggleExpanded(); $event.preventDefault()"
                (keydown.arrowRight)="node.expand()"
                (keydown.arrowLeft)="node.collapse()"
              ></tree-node-expander>
              <div
                class="node-content-wrapper width-full"
                [class.node-content-wrapper-active]="isNodeDisabled(node) ? false : node.isActive"
                [class.node-content-wrapper-focused]="isNodeDisabled(node) ? false : node.isFocused"
                [ngClass]="{ 'disabled-node-text': isNodeDisabled(node) }"
                (click)="node.mouseAction('click', $event)"
                (dblclick)="node.mouseAction('dblClick', $event)"
                (contextmenu)="node.mouseAction('contextMenu', $event)"
                (treeDrop)="node.onDrop($event)"
                [treeAllowDrop]="node.allowDrop"
                [treeDrag]="node"
                [treeDragEnabled]="node.allowDrag()"
              >
                <div class="is-flex is-flex-direction-row is-justify-content-space-between">
                  <div class="is-flex is-flex-direction-column is-word-wrap">
                    <div>
                      <tree-node-content [node]="node" [index]="index"></tree-node-content>
                      <span class="node-count" *ngIf="node.data?.count">
                        ({{ node.data.count }})
                      </span>
                    </div>
                    <div
                      class="white-space-no-wrap my-1"
                      *ngIf="isEntityTypeVisible(node, isDeviceMobile$ | async)"
                    >
                      <span
                        class="tag"
                        [ngClass]="node.level === 1 ? 'is-special' : 'is-actionable'"
                      >
                        {{ node.data?.entityType | readableEntityType }}
                      </span>
                    </div>
                    <span
                      class="is-size-7 has-text-weight-normal"
                      *ngIf="isFriendlyNameFeatureActive && node.data?.friendlyName"
                    >
                      {{ node.data.friendlyName }}
                    </span>
                    <div>
                      <span
                        class="is-size-7 text-ellipsis"
                        *ngIf="node.data?.path"
                        [attr.title]="node.data.path"
                      >
                        {{ node.data.path | middleEllipsisPath }}</span
                      >
                    </div>
                  </div>
                  <div
                    class="white-space-no-wrap mt-0_5"
                    *ngIf="isEntityTypeVisible(node, !(isDeviceMobile$ | async))"
                  >
                    <span
                      class="tag"
                      [ngClass]="node.level === 1 ? 'is-special' : 'is-actionable'"
                      >{{ node.data?.entityType | readableEntityType }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <ng-template #treeNodeFullTemplate let-node let-index="index" let-templates="templates">
            <div
              [class]="node.getClass()"
              [class.tree-node]="true"
              [class.tree-node-expanded]="node.isExpanded && node.hasChildren"
              [class.tree-node-collapsed]="node.isCollapsed && node.hasChildren"
              [class.tree-node-leaf]="node.isLeaf"
              [class.tree-node-active]="node.isActive"
              [class.tree-node-focused]="node.isFocused"
              [class.is-tree-filtered]="hasFilteredText"
            >
              <tree-node-drop-slot
                *ngIf="index === 0"
                [dropIndex]="node.index"
                [node]="node.parent"
              >
              </tree-node-drop-slot>

              <tree-node-wrapper
                [node]="node"
                [index]="index"
                [templates]="templates"
              ></tree-node-wrapper>

              <tree-node-children [node]="node" [templates]="templates"></tree-node-children>

              <div
                class="load-more"
                *ngIf="
                  node.isExpanded && node?.children && node?.children?.length < node?.data?.count
                "
              >
                <span
                  *ngIf="
                    !(loadingMore$ | async) && node?.data?.entityUid !== currentRootEntity;
                    else loadingTemplateForMore
                  "
                  class="button has-text-primary is-text pl-5"
                  (click)="onLoadMore(node)"
                  i18n
                >
                  Load more...
                </span>
                <ng-template #loadingTemplateForMore>
                  <div class="load-more-container" *ngIf="(loadingMore$ | async) === node.id">
                    <div class="spinner-container">
                      <div class="spinner" role="status" aria-live="assertive"></div>
                    </div>
                    <span i18n> Loading... </span>
                  </div>
                </ng-template>
              </div>

              <tree-node-drop-slot
                [dropIndex]="node.index + 1"
                [node]="node.parent"
              ></tree-node-drop-slot>
            </div>
          </ng-template>

          <ng-template #treeNodeTemplate let-node let-index="index">
            <div class="is-flex is-flex-direction-column">
              <div>
                <span class="is-size-6 is-inline-block">{{ node.data?.name }}</span>
                <span class="has-text-grey" *ngIf="node.data?.count">
                  ({{ node.data?.count }})
                </span>
              </div>
              <span class="is-size-7" *ngIf="node.data?.path">{{ node.data?.path }}</span>
            </div>
          </ng-template>
        </tree-root>

        <span class="has-text-truncate" *ngIf="loadingNewPortion$ | async">
          <portal-spinner [isSmall]="true"></portal-spinner>
        </span>
      </div>

      <hr class="dropdown-divider" />
      <div class="dropdown-item is-flex is-justify-content-space-between">
        <button
          class="button is-outlined"
          data-e2e="button-clear-all-filter"
          (click)="clearSelectedEntity()"
          (keydown.enter)="clearSelectedEntity()"
          type="button"
          title="Clear"
          i18n-title
          i18n
        >
          Clear
        </button>
        <button
          id="applyButton"
          class="button is-primary"
          (click)="onFilterApplied(true)"
          i18n
          title="Apply"
          i18n-title
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
